(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7964],{

/***/ 62935:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/faq",
      function () {
        return __webpack_require__(74707);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ faq; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/common/LinkTag/index.tsx
var LinkTag = __webpack_require__(23889);
// EXTERNAL MODULE: ./src/components/common/PaginationComponent.tsx + 3 modules
var PaginationComponent = __webpack_require__(40906);
// EXTERNAL MODULE: ./src/components/common/communication/magazine/ListMagazineLine.tsx + 2 modules
var ListMagazineLine = __webpack_require__(79476);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/StickyAppHeader/index.tsx + 3 modules
var StickyAppHeader = __webpack_require__(73487);
// EXTERNAL MODULE: ./src/styles/layout.ts
var layout = __webpack_require__(64952);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/components/templates/communication/Faq/FaqTemplate/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  max-width: 1152px;\n  flex-direction: column;\n  padding-bottom: 24px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 24px 8px 24px;\n  color: ",
        ";\n  ",
        ";\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  * > li {\n    list-style: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}













var FaqTemplate = function(param) {
    var client = param.client, viewModel = param.viewModel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                useSafeArea: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyAppHeader/* default */.Z, {
                    title: "건강 매거진"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Content */.Z.Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                    children: [
                        client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                                visible: true,
                                name: "1분 FAQ",
                                type: "faq",
                                path: "".concat(common/* ROUTES.FAQ.LIST.path */.Z6.FAQ.LIST.path)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTile, {
                                    children: "1분 FAQ"
                                }),
                                viewModel.faqs && /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                                    children: viewModel.faqs.map(function(faq) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                            href: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(faq.magazinePid),
                                            onClickNavigateToScreen: function() {
                                                return viewModel.onClickFaqDetail(faq.magazinePid);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListMagazineLine/* default */.Z, {
                                                magazine: {
                                                    title: faq.title,
                                                    mobileTitle: faq.title,
                                                    image: "",
                                                    date: faq.date,
                                                    magazinePid: faq.magazinePid,
                                                    description: faq.description,
                                                    mobileDescription: faq.description,
                                                    siteName: faq.siteName
                                                }
                                            })
                                        }, faq.magazinePid);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationComponent/* default */.Z, {
                                    totalPage: viewModel.totalPage,
                                    currentPage: Number(viewModel.queries.page),
                                    baseUrl: "".concat(common/* ROUTES.FAQ.LIST.path */.Z6.FAQ.LIST.path),
                                    scroll: false
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Faq_FaqTemplate = (FaqTemplate);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b347aaf-0"
})(_templateObject(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.white;
});
var BreadCrumbsWrapper = (0,styled_components_browser_esm/* default */.ZP)(BreadCrumbs/* default.Wrapper */.Z.Wrapper).withConfig({
    componentId: "sc-8b347aaf-1"
})(_templateObject1());
var Content = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    componentId: "sc-8b347aaf-2"
})(_templateObject2());
var PageTile = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-8b347aaf-3"
})(_templateObject3(), theme/* default.color.gray700 */.Z.color.gray700, theme/* default.typography.UI28SB */.Z.typography.UI28SB, layout/* Tablet */.YD, theme/* default.typography.UI22SB */.Z.typography.UI22SB);
var List = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b347aaf-4"
})(_templateObject4());

// EXTERNAL MODULE: ./src/entities/magazine/hook/useSearchMagazines.ts + 2 modules
var useSearchMagazines = __webpack_require__(50134);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/types/magazine.ts
var magazine = __webpack_require__(45162);
;// CONCATENATED MODULE: ./src/hooks/faq/useFaqViewModel.ts




var useFaqViewModel = function() {
    var ref = (0,useCustomRouter/* default */.Z)(), moveToPage = ref.moveToPage, router = ref.router;
    var _query = router.query, _page = _query.page, page = _page === void 0 ? "1" : _page;
    var ref1 = (0,useSearchMagazines/* default */.Z)({
        size: 20,
        page: Number(page),
        categoryIds: [],
        contentTypes: [
            magazine/* MagazineType.FAQ */.rL.FAQ
        ]
    }), faqs = ref1.magazines, isFaqsLoading = ref1.isLoading, totalPage = ref1.totalPage;
    var onClickFaqDetail = function(faqPid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(faqPid),
            mobileScreenName: common/* ROUTES.FAQ.DETAIL.appScreenName */.Z6.FAQ.DETAIL.appScreenName,
            params: {
                id: faqPid
            }
        });
    };
    return {
        queries: {
            page: page
        },
        totalPage: totalPage,
        faqs: faqs,
        isFaqsLoading: isFaqsLoading,
        onClickFaqDetail: onClickFaqDetail
    };
};
/* harmony default export */ var faq_useFaqViewModel = (useFaqViewModel);

// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/pages/content/faq/index.tsx
// PageDescription: 자주 묻는 질문 리스트 페이지







var FaqPage = function(param) {
    var client = param.client;
    var viewModel = faq_useFaqViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "닥터나우 1분 FAQ | 전문 의료진이 자주 묻는 질문에 답변해 드려요.",
                description: "비대면 진료, 약 처방, 진료비, 건강 관련 궁금증을 1분 만에 해결해보세요. 닥터나우 FAQ로 쉽고 빠르게 확인할 수 있어요.",
                openGraph: {
                    title: "닥터나우 1분 FAQ | 전문 의료진이 자주 묻는 질문에 답변해 드려요.",
                    description: "비대면 진료, 약 처방, 진료비, 건강 관련 궁금증을 1분 만에 해결해보세요. 닥터나우 FAQ로 쉽고 빠르게 확인할 수 있어요.",
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.FAQ.LIST.path */.Z6.FAQ.LIST.path).concat((0,url/* addQueryString */.sC)({
                        page: viewModel.queries.page
                    })),
                    images: [
                        {
                            url: "".concat("https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-magazine.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                },
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.FAQ.LIST.path */.Z6.FAQ.LIST.path).concat((0,url/* addQueryString */.sC)({
                    page: viewModel.queries.page
                })),
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: "비대면 진료 FAQ, 약 배송, 진료비, 탈모 처방, 여드름 약"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_FaqTemplate, {
                client: client,
                viewModel: viewModel
            })
        ]
    });
};
FaqPage.layout = DefaultLayout/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var faq = (FaqPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3063,9097,1498,2271,5615,175,7723,9774,2888,179], function() { return __webpack_exec__(62935); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);